import { useState, useEffect } from 'react';

const useRegistrationStatus = () => {
  const [registrationData, setRegistrationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRegistrationStatus = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
        const response = await fetch(`${apiUrl}/registration-status/`);
        if (response.ok) {
          const data = await response.json();
          setRegistrationData(data);
        } else {
          // Fallback data if API fails
          setRegistrationData({
            is_open: true,
            cohort_number: 4,
            beginners_form_url: "https://forms.gle/ujCb9YopPVzffiNR7",
            beginners_exp_form_url: "https://forms.gle/CfF4E5XbLXtea6ZB6",
            intermediates_form_url: "https://forms.gle/3ohjbbfEXGGzbv6AA"
          });
        }
      } catch (error) {
        console.error('Failed to fetch registration status:', error);
        // Fallback data
        setRegistrationData({
          is_open: true,
          cohort_number: 4,
          beginners_form_url: "https://forms.gle/ujCb9YopPVzffiNR7",
          beginners_exp_form_url: "https://forms.gle/CfF4E5XbLXtea6ZB6",
          intermediates_form_url: "https://forms.gle/3ohjbbfEXGGzbv6AA"
        });
      } finally {
        setLoading(false);
      }
    };

    fetchRegistrationStatus();
  }, []);

  return { registrationData, loading };
};

export default useRegistrationStatus;
